import React, { useRef, useEffect, memo, useImperativeHandle, forwardRef, useState } from 'react'
import List from '../List'
import classnames from 'classnames'
import Button, { ButtonGroup } from 'components/Base/Button'
import ScanCodeConsultButton from 'components/ScanCodeConsultButton'
import Lottie, { AnimationItem } from 'lottie-web'

import * as styles from './index.module.less'

interface ScenarioCardProps {
  className?: string
  dataSource?: any // 源数据
  isPc?: boolean // pc or mobile
  data?: JSON // lottie动画 json数据
  gif?: boolean // 是否为gif图片
}

const ScenarioCard: React.FC<ScenarioCardProps> = forwardRef(
  ({ className, dataSource, isPc = true, data, gif }, lottieRef: any) => {
    const { reverse = false } = dataSource
    const lottieWarp = useRef<any>(null)
    const lottieSvgInstance = useRef<AnimationItem>(null)
    const right_desc = isPc ? dataSource?.right_desc : dataSource?.right_desc_mb
    const title = isPc ? dataSource?.right_title : dataSource?.right_title_mb || dataSource?.right_title
    useEffect(() => {
      lottieSvgInstance!.current = Lottie.loadAnimation({
        container: lottieWarp.current,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data,
      })
    }, [])
    useImperativeHandle(lottieRef, () => ({
      // 播放
      play: () => {
        lottieSvgInstance!.current?.play()
      },
      // 离视口顶部距离
      getBoundingClientRect: () => lottieWarp!.current?.getBoundingClientRect(),
      // 返回第一帧并停止
      init: () => {
        lottieSvgInstance!.current?.goToAndStop(0, true)
      },
    }))
    return (
      <div
        className={classnames(
          styles.container,
          'lg:w-[1200px] pb-[30px] lg:pb-0 lg:h-[400px] rounded-[4px] lg:rounded-none lg:mx-auto lg:flex mx-[2rem] shadow-[0px_0px_20px_0px_rgba(153,169,191,0.2)] bg-[#fff] lg:shadow-none',
          { 'lg:flex-row-reverse': reverse },
          className,
        )}
        ref={lottieRef}
      >
        <div className="scenario-card-left lg:flex-1 px-[10px] pt-[10px] lg:px-0 lg:py-0">
          {isPc &&
            (gif !== undefined ? (
              <img
                className="w-full lg:w-[600px] h-full rounded-[4px]"
                src={gif ? dataSource?.left_card_gif?.publicURL : dataSource?.left_card_static?.publicURL}
                alt={dataSource?.img_alt}
                ref={lottieWarp}
                id="test"
              />
            ) : (
              <div ref={lottieWarp} className="checkImg lg:w-full h-full rounded-[4px] overflow-hidden" />
            ))}
          {!isPc && (
            <img
              className="checkImg w-full lg:w-[600px] h-full rounded-[4px]"
              src={dataSource?.left_card_static_mg?.publicURL}
              alt={dataSource?.img_alt}
            />
          )}
        </div>
        <div
          className={classnames('scenario-card-right lg:flex-1  lg:pt-[36px]', {
            'lg:pl-[28px]': !reverse,
            'lg:pr-[28px]': reverse,
          })}
        >
          <div className={classnames('lg:flex mt-[20px] lg:mt-auto text-center', { 'lg:flex-row-reverse': reverse })}>
            <span
              style={{
                background: `url(${dataSource?.right_icon?.publicURL}) no-repeat`,
                backgroundSize: '100% 100%',
              }}
              className=" lg:h-[60px] lg:w-[60px] hidden lg:block"
            />
            <span
              className={classnames(
                'right-title  text-[18px] font-medium  lg:h-[60px] lg:text-[24px] lg:rounded-[4px] text-[#04cb94] lg:border lg:border-[#04CB94] lg:bg-[#E5F9F4] text-center lg:leading-[60px] px-[20px]',
                { 'lg:ml-[20px]': !reverse, 'lg:mr-[20px]': reverse, 'right-arrow': reverse },
              )}
            >
              {title}
            </span>
          </div>
          <div
            className={classnames(
              ' mt-[20px]      mx-auto lg:mt-[46px] h-[30px] flex w-fit  rounded-[4px] shadow-[0px_0px_20px_0px_rgba(153,169,191,0.2)]',
              {
                'lg:flex-row-reverse': reverse,
                'lg:mr-0': reverse,
                'lg:ml-0': !reverse,
              },
            )}
          >
            <div className="h-full w-[30px] bg-[#04CB94] rounded-[4px] leading-[30px] text-center text-[20px] font-bold text-[#2C2C45]">
              Q
            </div>
            <div className="text-center whitespace-nowrap px-[10px]   text-[14px] text-[#475669] leading-[30px] font-medium">
              {right_desc}
            </div>
          </div>
          <div
            className={classnames(
              'lg:w-[446px] text-center lg:text-left px-[10px] lg:px-0 text-[14px] leading-[20px] mt-[8px] lg:mt-[14px] text-[#475669]',
              {
                'lg:text-right lg:mr-0 lg:ml-auto': reverse,
              },
            )}
          >
            {isPc ? dataSource?.right_content : dataSource?.right_content_mb}
          </div>
          <div>
            <List
              className="mt-[8px] hidden lg:block"
              data={dataSource?.menu}
              direction={reverse}
              childClassName="text-[14px] leading-[20px] text-[#475669] mb-[6px]"
            />
          </div>
          <div className="text-center lg:text-left">
            <ButtonGroup className={classnames('mt-[22px]', { 'lg:flex lg:flex-row-reverse': reverse })}>
              {dataSource?.btn_text_one && (
                <Button
                  btnType="primary"
                  className={styles.scenarioCard_primaryBtn}
                  href={dataSource?.btn_link_one}
                  size="small"
                  target="_blank"
                >
                  {dataSource?.btn_text_one}
                </Button>
              )}
              {!dataSource?.btn_link_two && (
                <ScanCodeConsultButton
                  className="lg:mx-[20px] ml-[16px] bg-[#fff] hover:!bg-[#E6FAF5]"
                  qrcode="https://ow-file.sensorsdata.cn/www/solutions/overview/wxcode.png"
                  size="small"
                  target="_blank"
                  buttonText={dataSource?.btn_text_two}
                  imgBottomText="微信扫码 立即咨询"
                  ghost
                  buttonType="primary"
                />
              )}
              {dataSource?.btn_link_two && (
                <Button btnType="default" href={dataSource?.btn_link_two} size="small" target="_blank">
                  {dataSource?.btn_text_two}
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>
      </div>
    )
  },
)

export default memo(ScenarioCard) as any
